<h2 mat-dialog-title>Ver {{ isRrhhView ? 'petición' : 'excepción' }} de teletrabajo</h2>

<mat-dialog-content>
  <div class="request-info">
    <table class="request-table">
      <colgroup>
        <col class="request-table-col-key" />
        <col class="request-table-col-value" />
      </colgroup>
      <tbody>
        @if (isRrhhView) {
          <tr>
            <th scope="row">Empleado</th>
            <td>
              <div class="employee-cell">
                <app-user-profile-picture [user]="request.user" [alt]="request.user.full_name" [css_class]="'employee-avatar'" />
                <span>{{ request.user.name }} {{ request.user.surnames }}</span>
              </div>
            </td>
          </tr>
        }
        <tr>
          <th scope="row">Semana</th>
          <td>{{ request.monday_date | date: 'dd/MM/yyyy' }}</td>
        </tr>
        <tr>
          <th scope="row">Estado</th>
          <td>
            <span [class]="'status-badge status-' + request.status">
              {{ EmployeeRequestResponsibleForAnswerStatusLabels[request.status] }}
            </span>
          </td>
        </tr>
        @if (request.reason_type) {
          <tr>
            <th scope="row">Tipo de razón</th>
            <td>{{ RemoteWorkWeekdayExceptionReasonTypeEnumLabels[request.reason_type] }}</td>
          </tr>
        }
        <tr>
          <th scope="row">Razón de la petición</th>
          <td>{{ request.reason }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>

@if (canRespond() && isRrhhView) {
  <mat-dialog-actions align="end">
    <button mat-flat-button color="warn" (click)="reject()">Rechazar</button>
    <button mat-flat-button color="accent" (click)="accept()">Aceptar</button>
  </mat-dialog-actions>
}
